<script setup>
import defaultLayout from '@/layouts/default.vue';
defineProps({
  error: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="error-wrapper">
    <defaultLayout :error-data="error" />
  </div>
</template>

<style scoped lang="scss">
.error-wrapper {
  $parent: &;

  display: flex;
  flex-direction: column;

  &:deep(#{$parent}__layout) {
    flex-grow: 1;
  }
}
</style>
